import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
// import { DoctorDate } from "../../types/doctorDateTime/DoctorDatetimeModal";
import { DoctorDate } from "../../types/doctorDateTime/DoctorDateTimeModal";
import axiosInstance from "../../axios/axiosInstance";

interface DoctorDateTimeState {
  doctorDateTimeLoading: boolean;
  doctorDateTimeSuccess: boolean;
  doctorDateTimeError: any;
  doctorDateTime: DoctorDate[];
}

const initialState: DoctorDateTimeState = {
  doctorDateTimeLoading: false,
  doctorDateTimeSuccess: false,
  doctorDateTimeError: "",
  doctorDateTime: [],
};

const apiUrl = process.env.BASE_URL;

export const getDoctorDateTime = createAsyncThunk<
  any,
  { doctor: number; bookingType: number }
>(
  "DoctorDateTimeData/getDoctorDateTimeData",
  async ({ bookingType, doctor }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${apiUrl}/doctor-time-slot/get-by-doctor/${doctor}/${bookingType}`
      );
      return response.data.doctorDates;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(
          "An Unknown error occurred while getting Doctor data"
        );
      }
    }
  }
);

const doctorDateTimeSlice = createSlice({
  name: "DoctorDateTime",
  initialState,
  reducers: {
    doctorDateTimeClearSuccess: (state) => {
      state.doctorDateTimeSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getDoctorDateTime.pending, (state) => {
        state.doctorDateTimeLoading = true;
        state.doctorDateTimeSuccess = false;
        state.doctorDateTimeError = null;
        state.doctorDateTime = [];
      })
      .addCase(getDoctorDateTime.fulfilled, (state, action) => {
        state.doctorDateTimeLoading = false;
        state.doctorDateTimeSuccess = true;
        state.doctorDateTime = action.payload;
      })
      .addCase(getDoctorDateTime.rejected, (state, action) => {
        state.doctorDateTimeLoading = false;
        state.doctorDateTimeError = action.payload;
        state.doctorDateTime = [];
      });
  },
});

export const { doctorDateTimeClearSuccess } = doctorDateTimeSlice.actions;
export default doctorDateTimeSlice.reducer;
